import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import PropTypes from "prop-types";
import { MenuLink } from "@reach/menu-button";
import { DropdownMenuItem } from "./dropdown-menu-item.es.js";
const propTypes = {
  as: PropTypes.elementType
};
const defaultProps = {
  as: void 0
};
const DropdownMenuLink = forwardRef(({ as, ...restProps }, ref) => /* @__PURE__ */ jsx(
  DropdownMenuItem,
  {
    ...restProps,
    as: MenuLink,
    forwardedAs: as,
    preventDefault: false,
    ref
  }
));
DropdownMenuLink.propTypes = propTypes;
DropdownMenuLink.defaultProps = defaultProps;
export {
  DropdownMenuLink
};
